const ALL_SCORES_SORT_CREATE_AT_DESC_OPTION_TEST_ID =
  'all-scores-sort-create-at-desc-option';
const ALL_SCORES_SORT_CREATE_AT_ASC_OPTION_TEST_ID =
  'all-scores-sort-create-at-asc-option';
const ALL_SCORES_SORT_HIGHEST_RATING_OPTION_TEST_ID =
  'all-scores-sort-highest-rating-option';
const ALL_SCORES_SORT_LOWEST_RATING_OPTION_TEST_ID =
  'all-scores-sort-lowest-rating-option';

export const ALL_SCORES_SORT_CREATE_AT_DESC_OPTION = {
  testId: ALL_SCORES_SORT_CREATE_AT_DESC_OPTION_TEST_ID,
  sortBy: 'CREATED_AT_DESC',
  label: 'Latest Added',
};

export const ALL_SCORES_SORT_CREATE_AT_ASC_OPTION = {
  testId: ALL_SCORES_SORT_CREATE_AT_ASC_OPTION_TEST_ID,
  sortBy: 'CREATED_AT_ASC',
  label: 'First Added',
};

export const ALL_SCORES_SORT_HIGHEST_RATING_OPTION = {
  testId: ALL_SCORES_SORT_HIGHEST_RATING_OPTION_TEST_ID,
  sortBy: 'RATING_DESC',
  label: 'Highest score',
};

export const ALL_SCORES_SORT_LOWEST_RATING_OPTION = {
  testId: ALL_SCORES_SORT_LOWEST_RATING_OPTION_TEST_ID,
  sortBy: 'RATING_ASC',
  label: 'Lowest score',
};

export const ALL_SCORES_SORT_OPTIONS = [
  ALL_SCORES_SORT_CREATE_AT_DESC_OPTION,
  ALL_SCORES_SORT_CREATE_AT_ASC_OPTION,
  ALL_SCORES_SORT_HIGHEST_RATING_OPTION,
  ALL_SCORES_SORT_LOWEST_RATING_OPTION,
];

export const ALL_SCORES_SORT_BUTTON_TEST_ID = 'all-score-sort-button';
export const ALL_SCORES_SORT_DROPDOWN_CONTENT_TEST_ID =
  'all-score-dropdown-content';
